/**
 * Guest-facing pages (no login) from app-routing.module.ts. AppComponent
 * leaves a logged-out visitor on these instead of sending them to /login.
 */
const PUBLIC_ROUTE_PREFIXES = [
  '/r/',
  '/manual-reservation/',
  '/manual-appointment/',
  '/cancel/',
  '/edit/',
  '/edit-appointment/',
  '/confirm/',
  '/forgot-password',
  '/register',
  '/404',
  '/500',
  '/book/',
  '/reschedule-general/',
];

export function isPublicRoute(url: string): boolean {
  return /^\/consent(?:[?#]|$)/.test(url) ||
    PUBLIC_ROUTE_PREFIXES.some((prefix) => url.startsWith(prefix));
}
